import { render, staticRenderFns } from "./interface.vue?vue&type=template&id=3a6cd866&scoped=true&lang=pug&"
import script from "./interface.vue?vue&type=script&lang=js&"
export * from "./interface.vue?vue&type=script&lang=js&"
import style0 from "./interface.vue?vue&type=style&index=0&id=3a6cd866&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6cd866",
  null
  
)

component.options.__file = "interface.vue"
export default component.exports